import { create } from 'zustand';

const useConfigStore = create((set) => ({
  entityPlansData: null,
  setEntityPlansData: (data) => set({ entityPlansData: data }),
}));

export default useConfigStore;
